// Sales State
import i18n from '@/i18n'

export default {
  salesList: [],
  saleInfo: {},
  reportUnclosedSalesCount: 0,
  reportUnPaidSalesCount: 0,
  unclosedSalesCount: 0,
  unPaidSalesCount: 0,
  receiveTypes: [{ text: i18n.t('Cash'), value: 'Cash' }, { text: i18n.t('On Account'), value: 'On Account' }]
}
